import React, { Component } from "react"
import PropTypes from "prop-types"
import ImPropTypes from "react-immutable-proptypes"
import { getExtensions } from "core/utils"
const propStyle = { color: "#999", fontStyle: "italic" }

const propClass = "property"

export default class ArrayModel extends Component {
  static propTypes = {
    schema: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired,
    getConfigs: PropTypes.func.isRequired,
    specSelectors: PropTypes.object.isRequired,
    name: PropTypes.string,
    displayName: PropTypes.string,
    required: PropTypes.bool,
    expandDepth: PropTypes.number,
    specPath: ImPropTypes.list.isRequired,
    depth: PropTypes.number,
    includeReadOnly: PropTypes.bool,
    includeWriteOnly: PropTypes.bool,
    relEndpoint: PropTypes.string
  }

  render(){
    let { getComponent, getConfigs, schema, depth, expandDepth, name, displayName, specPath, relEndpoint, visibilityOptions } = this.props
    const { showExtensions } = getConfigs()

    let description = schema.get("description")
    let items = schema.get("items")
    let title = schema.get("title") || displayName || name
    let extensions = getExtensions(schema)
    let properties = schema
      .filter( ( v, key) => ["type", "items", "description", "$$ref"].indexOf(key) === -1 )
      .filterNot( (v, key) => extensions.has(key) )

    const Markdown = getComponent("Markdown", true)
    const ModelCollapse = getComponent("ModelCollapse")
    const Model = getComponent("Model")
    const Property = getComponent("Property")

    const titleEl = title &&
      <span className="model-title">
        <span className="model-title__text">{ title }</span>
      </span>

    if(extensions && extensions.getIn(["x-ntap-introduced"])){
      extensions = extensions.deleteIn(["x-ntap-introduced"])
    }

    /*
    Note: we set `name={null}` in <Model> below because we don't want
    the name of the current Model passed (and displayed) as the name of the array element Model
    */
    return <span className="model">
      {getVisibilityBadge(visibilityOptions)}
      <ModelCollapse title={titleEl} expanded={ depth <= expandDepth } collapsedContent="[...]">
        [
          {
            properties.size ? properties.entrySeq().map( ( [ key, v ] ) => <Property key={`${key}-${v}`} propKey={ key } propVal={ v } propClass={ propClass }  propStyle={ propStyle }  />) : null
          }
          {
            showExtensions && extensions.size  ? extensions.entrySeq().map( ( [ key, v ] ) => <Property key={`${key}-${v}`} propKey={ key.replace('x-ntap-', '') } propVal={ v } propStyle={ propStyle } />) : null
          }
          {
            !description ? (properties.size ? <div className="markdown"></div> : null) :
              <Markdown source={ description } />
          }
          <span> <br/>
            <Model
              { ...this.props }
              getConfigs={ getConfigs }
              specPath={specPath.push("items")}
              name={null}
              schema={ items }
              required={ false }
              depth={ depth + 1 }
            />
          </span>
        ]
      </ModelCollapse>
    </span>
  }
}

function getVisibilityBadge (visibilityOptions) {
  if (typeof visibilityOptions === 'undefined') {
    return null;
  }
  let visibilityType = visibilityOptions.get('type').toUpperCase();
  let stylingClass = '';
  if (visibilityType == 'PRIVATE') {
    stylingClass = 'privateVisibilityBadgeModel';
  } else if (visibilityType == 'CONDITIONAL') {
    stylingClass = 'conditionalVisibilityBadgeModel';
  }
  return <span className={stylingClass}>{visibilityType}</span>;
}